<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare :content='content' :padding='false' class="m-b-20"></SmallSquare>
      <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="时间" name='time'>
          <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' class='m-b-15' @change="onChange" v-model:value="time" />
        </a-form-item>
        <a-form-item label="会员信息" name='member_keyword'>
          <a-input v-model:value="search.member_keyword" style="width:250px" placeholder="请输入微信昵称/ID进行搜索" allowClear />
        </a-form-item>
        <a-form-item label="有效期" name='blacklist_type'>
          <a-select v-model:value="search.blacklist_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="0">永久拉黑</a-select-option>
            <a-select-option :value="1">限时拉黑</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list' class="tableFixBox">
        <template v-slot:status="{ record }">
          <p>{{record.status?'正常':'禁用'}}</p>
        </template>
        <template v-slot:time="{ record }">
          <p>{{record.start_time}}至</p>
          <p>{{record.end_time}}</p>
        </template>
        <template v-slot:member="{ record }">
          <p>{{record.member_name}}</p>
          <p>(id:{{record.member_id}})</p>
        </template>
        <template v-slot:action="{ record }">
          <a-popconfirm title="确定要撤销该用户黑名单么？" ok-text="确定" cancel-text="取消" placement="topRight" class='m-r-10' @confirm="open(record)">
            <a href="javascript:;">撤销</a>
          </a-popconfirm>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { blacklistsLogs } from "@/api/qrcode";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  member_keyword: "",
  blacklist_type: "",
  start_time: "",
  end_time: "",
};
export default {
  name: "logs",
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let list = ref([]);
    const state = reactive({
      visibleInvite: false,
      visibleUrl: false,
      listId: [],
      listLoading: false,
      time: [],
      total: 1,
      selectedRowKeys: [],
      content:
        "黑名单上的用户将无法扫码查询防伪信息和参与扫码活动，黑名单身份可撤销。",
    });
    let columns = [
      {
        title: "会员信息",
        dataIndex: "member",
        key: "member",
        slots: { customRender: "member" },
      },
      {
        title: "时间",
        dataIndex: "time",
        key: "time",
        slots: { customRender: "time" },
      },
      {
        title: "有效期",
        dataIndex: "blacklist_limit",
        key: "blacklist_limit",
        customRender: ({ record }) => {
          return record.blacklist_limit == 0
            ? "永久"
            : record.blacklist_limit + "小时";
        },
      },
      {
        title: "原因",
        dataIndex: "remarks",
        key: "remarks",
      },
      {
        title: "释放时间",
        dataIndex: "releasing_time",
        key: "releasing_time",
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      if (!e.length) {
        search.value.start_time = "";
        search.value.end_time = "";
        return;
      }
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };
    const initData = async () => {
      state.listLoading = true;
      list.value = [];
      try {
        let res = await blacklistsLogs(search.value).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          list.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      onSelectChange,
    };
  },
};
</script>